export default __webpack_public_path__ + "static/drukarki_dzierzawa_MPC3504-fcdce7cadcb69c7af2fe8e749cce34d0.png";